import React from "react";
import { Route, Switch } from "react-router-dom";
import NotFound from "./NotFound/NotFound";
import NotAuthorized from "./NotFound/Authorize";
import HomePage from "./HomePage/index";
import AccountTransaction from "./Akode/AccountTransaction";
import AccountBalance from "./Akode/AccountBalance";
import PasswordChange from "./Password/Change";
import UserList from "./User/UserList";
import { useMediaQuery } from "react-responsive";
import AkodeReport from "./Akode/Report";


const App = ({ match }) => (
  <div
    className="gx-main-content-wrapper"
    style={{
      backgroundColor: "white",
      width: useMediaQuery({
        query: "(max-width: 1070px)",
      })
        ? ""
        : "99%",
    }}
  >
    <Switch>
      {/* Anasayfa */}
      {/* <Route path={`${match.url}`} component={asyncComponent(() => import('./HomePage/index'))}/> */}
      <Route path={`${match.url}home`} component={HomePage} />

      {/* Aköde hesap hareketleri */}
      <Route
        path={`${match.url}account-transaction`}
        component={AccountTransaction}
      />
      {/* Aköde hesap bakiyeleri */}
      <Route
        path={`${match.url}account-balance`}
        component={AccountBalance}
      />
      {/* Aköde Rapor */}
      <Route
        path={`${match.url}report`}
        component={AkodeReport}
      />
      {/* Şifre Değiştir */}
      <Route path={`${match.url}password-change`} component={PasswordChange} />
      {/* Kullanıcı Yetkiler */}
      <Route path={`${match.url}user-list`} component={UserList} />
      {/* Error */}
      <Route
        exact
        path={`${match.url}not-authorized-access`}
        component={NotAuthorized}
      />
      <Route component={NotFound} />
    </Switch>
  </div>
);

export default App;
